var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJsonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11V1H14.4462L20 6.42857V11",
    stroke: "#90A1AD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6V1L20 6H15Z",
    stroke: "#90A1AD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 10,
    transform: "translate(0 13)",
    fill: "#FDA906"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51259 15.5631H3.49358V18.502C3.49358 19.2847 3.27206 19.6761 2.62964 19.6761C2.01676 19.6761 1.81001 19.3142 1.92815 18.4503L0.931296 18.6275C0.72454 19.7425 1.27835 20.5105 2.60011 20.5105C3.8111 20.5105 4.51259 19.8164 4.51259 18.6423V15.5631Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48533 15.4893C6.22265 15.4893 5.49162 16.1612 5.49162 17.0252C5.49162 17.8374 6.00851 18.2509 7.36719 18.5241C8.17206 18.6866 8.4305 18.8416 8.4305 19.1075C8.4305 19.4767 8.09083 19.6834 7.46318 19.6834C6.806 19.6834 6.3408 19.5136 5.95682 18.8786L5.35132 19.6022C5.76483 20.1929 6.39248 20.5105 7.5001 20.5105C8.66679 20.5105 9.5012 19.964 9.5012 19.0484C9.5012 18.2361 9.00646 17.83 7.69209 17.5863C6.83553 17.4313 6.5697 17.2541 6.5697 16.9292C6.5697 16.5821 6.87984 16.331 7.49272 16.331C8.14991 16.331 8.55603 16.5895 8.80709 17.1138L9.50858 16.427C9.01385 15.7772 8.39358 15.4893 7.48533 15.4893Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5551 15.4893C11.1078 15.4893 10.207 16.4344 10.207 17.9999C10.207 19.5653 11.1078 20.5105 12.5551 20.5105C14.0024 20.5105 14.8959 19.5653 14.8959 17.9999C14.8959 16.4344 14.0024 15.4893 12.5551 15.4893ZM12.5551 16.3237C13.3674 16.3237 13.8399 16.9144 13.8399 17.9999C13.8399 19.0853 13.3674 19.6761 12.5551 19.6761C11.7355 19.6761 11.2629 19.0853 11.2629 17.9999C11.2629 16.9144 11.7355 16.3237 12.5551 16.3237Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1106 15.5631H19.195V18.3838L19.2245 19.2478H19.2098L18.7889 18.4208L17.0831 15.5631H15.9238V20.4366H16.8395V17.6159L16.8099 16.7519H16.8173L17.2382 17.5716L18.9439 20.4366H20.1106V15.5631Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25V28H20V25",
    stroke: "#90A1AD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsonIcon);
export default __webpack_public_path__ + "static/media/json-icon.b2bd0d8ef6497a00c02906d881430642.svg";
export { ForwardRef as ReactComponent };